export const format = (value?: string) => {
  if (!value) return ''

  if (Number.isNaN(parseFloat(value))) return value

  // Format value to czech format
  const formattedValue = new Intl.NumberFormat('cs-CZ').format(parseFloat(value))

  return formattedValue
}

export const parse = (value: string) => {
  // Replace any whitespace character with empty string
  const parsedValue = value.replace(/\s/gi, '')

  return parsedValue
}
